import {
  RepeatingTask,
  TaskFilterOptions,
  Timestamp,
  User,
} from '@griply/types';
import { filterRepeatingTasks, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';

export type UseFilteredRepeatingTasksInput = {
  repeatingTasks: RepeatingTask[];
  filters: TaskFilterOptions | TaskFilterOptions[];
  today: Timestamp;
  user: User | null | undefined;
};

export const useFilteredRepeatingTasks = ({
  repeatingTasks,
  filters,
  today,
  user,
}: UseFilteredRepeatingTasksInput): RepeatingTask[] => {
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    return filterRepeatingTasks({
      repeatingTasks,
      filters: filtersArray,
      weekStartsOn,
      today,
    });
  }, [filters, repeatingTasks, today, weekStartsOn]);
};
